import $http from '../../../axios-instance';
import Swal from 'sweetalert2'

/**
 * Método para obtener la información de la asignacion de un producto químico a las empresas.
 *
 * @param {*} param0
 * @param {*} prod contiene el id del producto.
 */
export async function getInfoAsignacion({ commit, state, rootState }, id) {
	await $http.get(`adm_productos/asignacion_basica/${id}`)
		.then((response) => {
			commit("cargarInfoProducto", response.data.data.infoProducto);
			commit("cargarAsignaciones", response.data.data.asignaciones);
		})
}


export async function validaAsignacion({commit, state, rootState, dispatch}, asignacion) {

  if (!asignacion.asignado) {
    await $http.get(`adm_productos/asignacion_basica/${state.infoProducto.id}/${asignacion.id}`)
      .then(async (response) => {
        let asignacion_respuesta = response.data.data.asignacion

        if (asignacion_respuesta.activo_rpq || asignacion_respuesta.pago) {
          Swal.fire({
            position: 'center',
            icon: 'warning',
            title: "No es posible quitar la asignación del producto debido a que se encuentra asignado para RPQ",
            showConfirmButton: false,
            timer: 2000
          })
          commit('cargarAsignacion', asignacion_respuesta)
        } else {

          let comments = "";
          if ('comments' in asignacion) comments = asignacion.comments

          await dispatch('inactivarAsignacion', { ...asignacion_respuesta, comments  })
        }
      })
  } else {
    await dispatch('guardaAsignacion', asignacion)
  }

  await dispatch('getInfoAsignacion', state.infoProducto.id)
  commit('setModalAsignacionCargarUbicaciones', true)
  commit('setModalAsignacionCargarCamposPersonalizados', true)

}

export async function inactivarAsignacion({commit, state, rootState, dispatch}, asignacion) {
  await Swal.fire({
    title: 'Eliminar la asignación',
    text: "¿Está seguro de eliminar la asignación de " + asignacion.nombre + " ?",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Si, Eliminar'
  }).then(async (result) => {
    if (result.value) {
     commit("dashboard/load", true, { root: true });
      await $http.post(`adm_productos/asignacion_basica/inactivar/${state.infoProducto.id}`, asignacion)
        .then((response) => {
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: response.data.message,
            showConfirmButton: false,
            timer: 1500
          })
        })
        .catch((error) => {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message + '<br> ' + error.errors,
            showConfirmButton: true,
            timer: 2000
          })
        }).finally(() => {
              commit("dashboard/load", false, { root: true });
          })
    } else if (result.dismiss) {
      commit('cargarAsignacion', asignacion)
    }
  })
}

/**
 * Método para guardar la asignación de los productos químicos a las empresas.
 *
 * @param {*} param0
 * @param {*} asignacion  contiene la información para la asignación.
 */
export async function guardaAsignacion({ commit, state, rootState, dispatch }, asignacion) {
  commit('dashboard/load', true, {root: true});
  await $http.post(`adm_productos/asignacion_basica/crear/${state.infoProducto.id}`, asignacion)
    .then((response) => {
      commit('dashboard/load', false, {root: true});
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: response.data.message,
        showConfirmButton: false,
        timer: 1500
      })
    })
    .catch((error) => {
      commit('dashboard/load', false, {root: true});
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error.message + '<br> ' + error.errors,
        showConfirmButton: true,
        timer: 2000
      })
    })
}


/**
 * Método para guardar la asignación de los productos químicos a las empresas.
 *
 * @param {*} param0
 * @param {*} asignacion  contiene la información para la asignación.
 */
export async function assingProductByCompany({ commit, state, rootState, dispatch }, payload) {
    commit('dashboard/load', true, {root: true});
    await $http.post(`product-company/assing-by-company`, payload)
      .then((response) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: response.data.message,
          showConfirmButton: false,
          timer: 1500
        })
      })
      .catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: error.message + '<br> ' + error.errors,
          showConfirmButton: true,
          timer: 2000
        })
        throw new Error('Error en el servicio');
      })
  }

/**
 * Método para obtenerlas empresas asignadas al producto.
 *
 * @param {*} param0
 */
export async function getEmpresasAsig({ commit, state, rootState /* , dispatch  */ }, id) {

  if (state.modalAsignacion.cargarUbicaciones) {

    await $http.get(`adm_productos/asignacion_basica/empresas/${id}`, state)
      .then((response) => {
        state.empresas = [];
        commit('cargarEmpresasBasesAreas', response.data.empresas)
        commit('setModalAsignacionCargarUbicaciones', false)
      })
  }
}

/**
 * Método para obtenerlas empresas asignadas al producto.
 *
 * @param {*} param0
 * @param id_producto
 * @param id_empresa
 */
export async function getCamposPersonalizados({ commit, state, rootState}, {id_producto, id_empresa}) {

  let empresa_id
  let id_contratista = null

  if (id_empresa && id_empresa.toString().includes('.')){
    let partes = id_empresa.toString().split('.')
    empresa_id = partes[0]
    id_contratista = partes[1]
  }else{
    empresa_id = id_empresa
  }

  await $http.get(`adm_productos/asignacion_basica/campos_personalizados/empresas/${id_producto}?id_empresa=${empresa_id}&id_contratista=${id_contratista}`, state)
    .then((response) => {
      commit('setCamposPersonalizados', response.data.empresas)
    })

}

/**
 * Método para obtener las bases y areas asignadas al producto químico.
 *
 * @param {*} param0
 * @param {*} id_empresa id de la empresa.
 */
export async function getUbicacionProd({ commit, state, rootState }, info) {

  let id_empresa = null;
  let id_contratista = null
  if (info.empresa && info.empresa.toString().includes('.')){
    let partes = info.empresa.toString().split('.')
    id_empresa = partes[0]
    id_contratista = partes[1]
  }else{
    id_empresa = info.empresa
  }
  let params = {
    params: {
      esEmpresa: info.esEmpresa
    }
  }
  if(!id_empresa)id_empresa = state.selected_empresa.id;

  commit('dashboard/load', true, {root: true});

	await $http.get(`adm_productos/ubicaciones/${info.producto}/${id_empresa}?id_contratista=${id_contratista}`, params)
		.then((response) => {
      commit('dashboard/load', false, {root: true});
			commit('setUbicaciones', response.data.data)
		}).catch(() => {
      commit('dashboard/load', false, {root: true});
    })
}

/**
 * Método para obtener las bases y areas asignadas al producto químico.
 *
 * @param {*} param0
 * @param {*} id_empresa id de la empresa.
 */
export async function asignarUbicacionProd({ commit, state }, id) {

  commit('dashboard/load', true, {root: true});

	await $http.post(`adm_productos/ubicaciones/${id}`, state.selectedUbicacion)
		.then(async (response) => {
      commit('dashboard/load', false, {root: true});
			await Swal.fire({
				position: 'center',
				icon: 'success',
				title: response.data.message,
				showConfirmButton: false,
				timer: 1500
			})
			state.errorUbicacion = false
		})
		.catch((error) => {
      commit('dashboard/load', false, {root: true});
			state.errorUbicacion = true
			Swal.fire({
				position: 'center',
				icon: 'error',
				title: error.message + '<br> ' + error.error,
				timer: 2000
			})
		})
}

export async function guardaUbicacion({state, commit}, data) {

  return new Promise(async (resolve, reject) => {
    let parametros = {
      ubicaciones: state.ubicSelecc,
      id_empresa : data.empresa_id
    }

    commit('dashboard/load', true, {root: true});

    await $http.post(`adm_productos/ubicaciones-masiva/${data.producto_id}`, parametros)
      .then(async (response) => {
        commit('dashboard/load', false, {root: true});
          await Swal.fire({
            position: 'center',
            icon: 'success',
            title: response.data.message,
            showConfirmButton: false,
            timer: 1500
          })
        resolve(response.data)
      })
      .catch((error) => {
        commit('dashboard/load', false, {root: true});
        reject(error)
      })
  })

}

/**
 * Método para guardar los campos personalizados del producto en especifico.
 *
 * @param {*} param0
 * @param {*} informacion contiene la información de los campos personalizados.
 */
export async function guardarCamposPer({ commit, state, rootState }, info) {

	var producto = info.producto;

	if (producto == undefined) {
    producto = rootState.productos.selectedProduct.id;
	}

	//commit('cargaCamposPersonalizados', info.empresa.campos_personalizados[0]);

	await $http.post(`adm_productos/campos_personalizados/crear/${producto}`, info)
		.then((response) => {
			Swal.fire({
				position: 'center',
				icon: 'success',
				title: response.data.message,
				showConfirmButton: false,
				timer: 1000
			})
		})
		.catch((error) => {

		})

}

/**
 * Método que devuelve las ultimas ubicaciones segun producto y empresa.
 *
 * @param {*} data contiene el id del producto y la empresa.
 * @return {Array}
 *
 * @author Brandon Torres
 */
export async function listarUbicacionesCantidad({commit}, data) {
    commit('dashboard/load', true, {root: true});
    await $http.post(`company/location-quantitie/${data.company_id}/location-level`, data)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setUbicacionesCantidad', response.data)
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

/**
 * Método que crea la cantidad de un producto en una ubicación.
 *
 * @param {*} data contiene la informacion del producto ubicaciones cantidad.
 *
 * @author Brandon Torres
 */
 export async function guardarUbicacionesCantidad({commit}, data) {
    commit('dashboard/load', true, {root: true});
    await $http.post(`company/location-quantitie/${data.company_id}/create`, data)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
				position: 'center',
				icon: 'success',
				title: response.data.message,
				showConfirmButton: false,
				timer: 1000
			})
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function changeUseProductCompany(
    { commit, state, rootState, dispatch },
    data
) {
    try {
        const title = data.in_use ? "Activar" : "Desactivar";
        await Swal.fire({
            title: title + " disponibilidad en el inventario",
            text:
                "¿Está seguro que deseas " +
                title.toLocaleLowerCase() +
                " la disponibilidad en el inventario de este producto en esta empresa?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Si, " + title.toLocaleLowerCase(),
        }).then(async (result) => {
            if (result.value) {
                commit("dashboard/load", true, { root: true });
                const res = await $http.post(
                    "product-company/change-use",
                    data
                );
                commit("dashboard/load", false, { root: true });
                Swal.fire({
                    position: "center",
                    icon: "success",
                    title: res.data.message,
                    showConfirmButton: false,
                    timer: 1000,
                });
            } else {
                await $http
                    .get(
                        `adm_productos/asignacion_basica/${data.product_id}`,
                        state
                    )
                    .then((response) => {
                        commit(
                            "cargarInfoProducto",
                            response.data.data.infoProducto
                        );
                        commit(
                            "cargarAsignaciones",
                            response.data.data.asignaciones
                        );
                    });
            }
        });
    } catch (error) {
        Swal.fire({
            position: "center",
            icon: "error",
            title: error.message,
            showConfirmButton: true,
            timer: 5000,
        });
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * Guardar campos personalizados de un producto.
 *
 * @param {*} commit dashboard/load
 * @param {*} data contiene la informacion de los campos personalizados.
 * @returns {Promise<void>}
 * @author Brandon Torres
 */
export async function saveFieldsCustoms({ commit }, data) {
    commit("dashboard/load", true, { root: true });
    await $http
        .post('productsFieldsCustum/createOrUpdateMany', data)
        .then((response) => {
            commit("dashboard/load", false, { root: true });
            Swal.fire({
                position: "center",
                icon: "success",
                title: response.data.message,
                showConfirmButton: false,
                timer: 1000,
            });
        })
        .catch((error) => {
            commit("dashboard/load", false, { root: true });
            Swal.fire({
                position: "center",
                icon: "error",
                title: error.message,
                showConfirmButton: true,
                timer: 5000,
            });
        }).finally(() => {
            commit("dashboard/load", false, { root: true });
        });
}
